
let currentTargetFOV = 0;

export function tweenFOV(camera, targetFOV, time){
    if(currentTargetFOV === targetFOV) return;
    currentTargetFOV = targetFOV;
    return new TWEEN.Tween(camera)
        .to({fov: currentTargetFOV}, time)
        .easing(TWEEN.Easing.Linear.None)
        .onUpdate(() => {
            camera.updateProjectionMatrix()
            // console.log('update tween')
        })
        .onComplete(() => {
            camera.updateProjectionMatrix()
        })
        .start();
}
